import React from 'react';

import SVGIcon from 'src/components/svg';
import BaseAnalyseItem from 'src/components/analyse/item';
import { lang, userFullName } from 'src/helpers';

export default class AnalyseItem extends BaseAnalyseItem {
  render() {
    const { item, auth, partnerName } = this.props;
    return (
      <div className={'mc-flex-15-col'}>
        <div className={'mc-value-518 mc-b2b mc-pb5'}>
          {lang.t('Analyses ')}
          <span className={'mc-value-416'}>{lang.t('added by ')}</span>
          {item.from === auth?.id ? userFullName(auth, auth?.isDoctor) : partnerName}
        </div>
        <a
          className={'mc-flex-15'}
          href={item.media && item.media[0]?.uri}
          target='_blank'
          rel='noreferrer'
        >
          <div className={'mc-icon-box'}>
            <SVGIcon iconname={this.iconname()} />
          </div>
          <div className={'mc-value-618 mc-grow'}>{item.text}</div>
        </a>
      </div>
    );
  }
}
